export default "__VITE_ASSET__BCWP0QM5__"